import React, {FC, useEffect, useState} from "react";
import {useLocale} from "@/contexts/localeContext.tsx";
import {useDialog} from "@/components/dialog/DialogContext.tsx";
import {useFormikContext} from "formik";
import {ExecuteCommand} from "@/models/ExecuteCommand.ts";
import Commands from "@/constants/commands.ts";
import {authSubCmds} from "@/constants/sub-commands.ts";
import {executeCommand} from "@/services/executeCommandService.ts";
import {getErrorMessage} from "@/services/utilities/ServiceError.ts";
import {TranslationKeys} from "@/contexts/TranslationKeys.ts";
import ChooseModal from "@/components/choose-modal/ChooseModal.tsx";

interface SearchGroupProps {
    isOpen: boolean;
    setIsOpen: (isOpen: boolean) => void;
    forceNextStep:(isEnabled: boolean) => void;
    title: string;
    setStepDescriptions: React.Dispatch<React.SetStateAction<{ [key: string]: string }>>;
}

const SearchGroupModal: FC<SearchGroupProps> = ({ isOpen, setIsOpen, title, forceNextStep, setStepDescriptions }) => {
    const { translate } = useLocale();
    const dialog = useDialog();
    const { values, setFieldValue, setFieldTouched } = useFormikContext<any>();
    const [listItems, setListItems] = useState(new Array(0));
    const [commonNameResults, setCommonNameResults] = useState<any[]>([]);

    const getCommonNames = async () => {
        const command: ExecuteCommand = {
            cmd: Commands.Account.label,
            cmdSubType: authSubCmds.ENTRA_SEARCH_GROUPS_BY_CN,
            searchTerm: values.searchByCn,
        }

        await executeCommand(command).then((response: any) => {
            setCommonNameResults(response.message);
        }).catch((error) => {
            dialog.pushError({ message: getErrorMessage(error), title: translate.byKey(TranslationKeys.error) })
        });
    }

    // Needs to be async to give formik a chance to realise
    // that the values have been updated.
    const rowSelect = async (item: any) => {
        setStepDescriptions(prev => ({...prev, groupName: item?.displayName}))
        await setFieldValue("idpGroupName", item?.displayName);
        await setFieldValue("identityProviderGroupId", item?.id);
        await setFieldValue("idpGroupDescription", '');
        await setFieldValue("profileName", '');
        await setFieldValue("profileId", 0);
        await setFieldValue("id", 0);
        setCommonNameResults(new Array(0));
        await setFieldTouched('idpGroupName', true);
        await setFieldTouched('identityProviderGroupId', true);
        forceNextStep(true);
        setIsOpen(false);
    }

    const buildListItem = (item) => {
        return {
            value: item,
            isSelected: false,
            label: item.displayName,
            site: null,
            optionalColumns: null
        };
    };

    useEffect(() => {
        setListItems(commonNameResults!.map(buildListItem));
    }, [commonNameResults]);

    return <ChooseModal isOpen={isOpen}
             setIsOpen={setIsOpen}
             title={title}
             subtitle={translate.byKey(TranslationKeys.searchByName)}
             getCommonNames={getCommonNames}
             rowSelect={rowSelect}
             listItems={listItems} />
}
export default SearchGroupModal;
